import {
    AutocompleteInput,
    NumberInput,
    TextInput,
    required,
    useGetList,
} from 'react-admin';
import { SimpleForm } from '@components/SimpleForm';
import { format } from '@src/helpers/numeric.ext';
import { Grid } from '@mui/material';
import { entityResource as ent } from '@src/entityResource';

export const GoodsForm = () => {
    const { data: categories, isPending } = useGetList(
        ent.GOODS.CATEGORIES_API
    );

    const handleCategoryOnCreate = (filter: string | undefined) => {
        const newCategoryName = filter || '';
        const newCategory = { id: newCategoryName, name: newCategoryName };
        if (categories) {
            categories.push(newCategory);
        }
        return newCategory;
    };

    const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            const filter = (event.target as HTMLInputElement).value;
            const newCategory = handleCategoryOnCreate(filter);
            (event.target as HTMLInputElement).value = newCategory.name;
        }
    };

    return (
        <SimpleForm>
            <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                    <AutocompleteInput
                        source="category"
                        choices={categories}
                        optionText="name"
                        optionValue="id"
                        validate={[required()]}
                        isPending={isPending}
                        onKeyUp={handleKeyUp}
                        onCreate={handleCategoryOnCreate}
                        TextFieldProps={{
                            placeholder:
                                'Kategori Baru (tekan enter untuk menyimpan)',
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextInput source="code" validate={[required()]} />
                </Grid>
                <Grid item xs={12} md={8}>
                    <TextInput source="name" validate={[required()]} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <NumberInput source="purchasePrice" format={format} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <NumberInput source="sellingPrice" format={format} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <NumberInput source="stock" format={format} />
                </Grid>
            </Grid>
        </SimpleForm>
    );
};
